import { render, staticRenderFns } from "./tabs-primary.vue?vue&type=template&id=1882f796&scoped=true&"
import script from "./tabs-primary.vue?vue&type=script&lang=js&"
export * from "./tabs-primary.vue?vue&type=script&lang=js&"
import style0 from "./tabs-primary.vue?vue&type=style&index=0&id=1882f796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1882f796",
  null
  
)

export default component.exports